import { cn } from '../lib/cn'
import { describeHotkey, formatHotkey, type Hotkey } from '../lib/hotkeys'

export interface KbdProps {
  /** 'mod+k', 'g b', 'shift+?' – angezeigt passend zum Betriebssystem */
  hotkey: Hotkey
  /** 'plain': ohne Kästchen (in Schaltflächen und Tooltips) */
  variant?: 'boxed' | 'plain'
  className?: string
}

/** Zeigt ein Tastenkürzel: ⌘K auf macOS, Strg K sonst. */
export function Kbd({ hotkey, variant = 'boxed', className }: KbdProps) {
  // Folgen („g b“) stehen mit Abstand, Kombinationen („mod+k“) eng beieinander
  const chords = hotkey
    .trim()
    .split(/\s+/)
    .map((chord) => formatHotkey(chord))
  return (
    <kbd
      aria-label={describeHotkey(hotkey)}
      className={cn('inline-flex shrink-0 items-center gap-1 font-sans select-none', className)}
    >
      {chords.map((keys, chordIndex) => (
        <span
          key={chordIndex}
          aria-hidden
          className={cn(
            'inline-flex items-center text-micro tracking-normal normal-case',
            keys.every((key) => key.length === 1) ? 'gap-px' : 'gap-1',
            variant === 'boxed'
              ? 'h-4.5 min-w-4.5 justify-center rounded-xs border border-line bg-sunken px-1 text-fg-muted'
              : 'opacity-70',
          )}
        >
          {keys.map((key, index) => (
            <span key={index}>{key}</span>
          ))}
        </span>
      ))}
    </kbd>
  )
}
